import {
  HS_PAXSCREENING_DISPLAY_STATUS,
  HS_PAXSCREENING_STATUS_COLORS,
} from '@/module/all-screenings/constants';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles({
  chip: {
    minWidth: 82,
    color: (props) => props.color,
    backgroundColor: (props) => props.backgroundColor,
  },
});

export const StatusComponent = ({
  status,
  filterList = HS_PAXSCREENING_DISPLAY_STATUS,
  filterListColor = HS_PAXSCREENING_STATUS_COLORS,
}) => {
  let displayStatus = filterList[status] || status;
  let color = filterListColor[displayStatus]?.txt || '#23A6CC';
  let backgroundColor =
    filterListColor[displayStatus]?.background || '#23a6cc29';
  const classes = useStyles({ color, backgroundColor });

  const customStartCase = (str) => {
    if (!str || typeof str !== 'string') return str;
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase words
      .replace(/[_-]+/g, ' ') // Replace underscores and dashes with spaces
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .trim() // Trim leading and trailing spaces
      .toLowerCase() // Convert to lowercase
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  };

  return (
    <Chip
      size="small"
      className={classes.chip}
      label={customStartCase(displayStatus)}
    />
  );
};
